module.exports = __webpack_public_path__ + "img/02.4bd2df7d.jpg";